import type { JobStats } from '../../types/job';
import type { OrderStats } from '../../types/order';
import type { TaskStats } from '../../types/task';

export type DonutSlice = { name: string; value: number };

export const openOrders = (s: OrderStats) =>
  Math.max(0, s.total - s.completed - s.cancelled);

export const activeJobs = (s: JobStats) =>
  Math.max(0, s.total - s.completed - s.cancelled);

export const openTasks = (s: TaskStats) =>
  Math.max(0, s.total - s.completed - s.cancelled);

export function orderStatsToDonut(s: OrderStats): DonutSlice[] {
  const rows: DonutSlice[] = [
    { name: 'Pending', value: s.pending },
    { name: 'Confirmed', value: s.confirmed },
    { name: 'In progress', value: s.in_progress },
    { name: 'Completed', value: s.completed },
    { name: 'Cancelled', value: s.cancelled },
    { name: 'On hold', value: s.on_hold },
  ];
  return rows.filter(r => r.value > 0);
}

export function instanceStatusDonut(s: {
  available: number;
  rented: number;
  maintenance: number;
  damaged: number;
}): DonutSlice[] {
  const rows: DonutSlice[] = [
    { name: 'Available', value: s.available },
    { name: 'Rented', value: s.rented },
    { name: 'Maintenance', value: s.maintenance },
    { name: 'Damaged', value: s.damaged },
  ];
  return rows.filter(r => r.value > 0);
}
